import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyAz_1jHg2HFWV9Z2e-QC25UnvImwgEDz6M',
  authDomain: 'translate-1eb72.firebaseapp.com',
  databaseURL: 'https://translate-1eb72.firebaseio.com',
  projectId: 'translate-1eb72',
  storageBucket: 'translate-1eb72.appspot.com',
  messagingSenderId: '919995005218',
  appId: '1:919995005218:web:6b3e0290c51d5d30770d7b',
}

const firebaseConfig2 = {
  apiKey: 'AIzaSyDkwvBliqG8UT9ii5OYlP6umVNDWUIq7kk',
  authDomain: 'slack2-e42f4.firebaseapp.com',
  databaseURL: 'https://slack2-e42f4.firebaseio.com',
  projectId: 'slack2-e42f4',
  storageBucket: 'slack2-e42f4.appspot.com',
  messagingSenderId: '352985802659',
  appId: '1:352985802659:web:e9adc84f656eeb6ed81c16',
  measurementId: 'G-GKYSF28FG6',
}

const firebaseConfig3 = {
  apiKey: 'AIzaSyBaiAAI8cy1YPbhvtfzSi-JeR4Htb1FMns',
  authDomain: 'slack3-26468.firebaseapp.com',
  projectId: 'slack3-26468',
  storageBucket: 'slack3-26468.appspot.com',
  messagingSenderId: '306821704611',
  appId: '1:306821704611:web:3b7fc9dc526f06caa5c816',
}

const slackApp = firebase.initializeApp(firebaseConfig)
const slack2App = firebase.initializeApp(firebaseConfig2, 'slack2')
const slack3App = firebase.initializeApp(firebaseConfig3, 'slack3')

// Initialize Firebase
export default {
  slack: slackApp,
  slack2: slack2App,
  slack3: slack3App,
}
